import { IconProps } from '@/types';
import React from 'react';

export const Home = ({
  color = '#3971C0',
  height = '20',
  width = '21',
}: IconProps) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 18.3333V9.99996H13V18.3333M3 7.49996L10.5 1.66663L18 7.49996V16.6666C18 17.1087 17.8244 17.5326 17.5118 17.8451C17.1993 18.1577 16.7754 18.3333 16.3333 18.3333H4.66667C4.22464 18.3333 3.80072 18.1577 3.48816 17.8451C3.17559 17.5326 3 17.1087 3 16.6666V7.49996Z"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
